// extracted by mini-css-extract-plugin
export default {"overlay":"TooltipWrapper_overlay__KPxav","padding_big":"TooltipWrapper_padding_big__G+S0I","padding_none":"TooltipWrapper_padding_none__WlqvP"};